__turbopack_context__.v({
  "achievementPopupInner": "cXBJxW_achievementPopupInner",
  "backButton": "cXBJxW_backButton",
  "content": "cXBJxW_content",
  "copy": "cXBJxW_copy",
  "shareButton": "cXBJxW_shareButton",
  "shareButtons": "cXBJxW_shareButtons",
  "shareImage": "cXBJxW_shareImage",
  "title": "cXBJxW_title",
});
